import { css, injectGlobal } from "@emotion/css";

injectGlobal`
    .sds-notification {
        left: 50%;
        transform: translateX(-50%);
        width: 320px;
    }
`;

export const globalNotificationStyle = css`
    background: rgba(255, 255, 255, 82%);
    box-shadow: 0 12px 20px rgba(0, 0, 0, 8%);

    .sds-notification-info-body,
    .sds-notification-success-body {
        border: none;
    }
`;
